import React from "react";
import NovaFloatingIcon from "./NovaFloatingIcon";
import CreateWithNovaAiModal from "./CreateWithNovaAiModal";
import useNovaChatBotWrapper from "./hooks/useNovaChatBotWrapper";

const NovaChatBotWrapper = () => {
  const {
    propsForGoalsNovaAi,
    showUserMessage,
    setShowUserMessage,
    showNovaChatFromNovaIcon,
    setShowNovaChatFromNovaIcon,
    isAiEnabled,
    isNovaChatBotOpen,
    isMobileView,
    showNovaChatBotIcon,
    conversationId,
    isNewConversation,
    isNovaGoalsAiEnabled,
    isConversationMessagesLoading,
  } = useNovaChatBotWrapper();

  if (!isAiEnabled) return null;

  return (
    <>
      {!isMobileView && isNovaChatBotOpen && isNovaGoalsAiEnabled && (
        <CreateWithNovaAiModal
          {...propsForGoalsNovaAi}
          product="goals"
          showUserMessage={showUserMessage}
          setShowUserMessage={setShowUserMessage}
          isNewConversation={isNewConversation}
          isNovaChatBotOpen={isNovaChatBotOpen}
          isConversationMessagesLoading={isConversationMessagesLoading}
        />
      )}
      {showNovaChatBotIcon && (
        <NovaFloatingIcon
          setShowUserMessage={setShowUserMessage}
          conversationId={conversationId}
          showNovaChatFromNovaIcon={showNovaChatFromNovaIcon}
          setShowNovaChatFromNovaIcon={setShowNovaChatFromNovaIcon}
        />
      )}
    </>
  );
};

export default NovaChatBotWrapper;
